export interface RouteConfig {
  path: string
  label: string
  parent?: string
  section: 'home' | 'settings' | 'engage' | 'coach' | 'admin'
}

export const routeConfig: RouteConfig[] = [
  // Home
  { path: '/', label: 'Home Dashboard', section: 'home' },

  // Platform Settings
  { path: '/settings', label: 'Platform Settings', section: 'settings' },
  { path: '/settings/account', label: 'Account & Billing', parent: '/settings', section: 'settings' },
  { path: '/settings/account/organization', label: 'Organization Profile', parent: '/settings/account', section: 'settings' },
  { path: '/settings/account/subscription', label: 'Subscription & Plan', parent: '/settings/account', section: 'settings' },
  { path: '/settings/account/billing', label: 'Billing & Invoices', parent: '/settings/account', section: 'settings' },
  { path: '/settings/account/usage', label: 'Usage Dashboard', parent: '/settings/account', section: 'settings' },
  { path: '/settings/team', label: 'Team & Permissions', parent: '/settings', section: 'settings' },
  { path: '/settings/team/members', label: 'Team Members', parent: '/settings/team', section: 'settings' },
  { path: '/settings/team/roles', label: 'Roles & Permissions', parent: '/settings/team', section: 'settings' },
  { path: '/settings/team/audit', label: 'Access Audit Log', parent: '/settings/team', section: 'settings' },
  { path: '/settings/team/sso', label: 'SSO Configuration', parent: '/settings/team', section: 'settings' },
  { path: '/settings/integrations', label: 'API & Integrations', parent: '/settings', section: 'settings' },
  { path: '/settings/integrations/api-keys', label: 'API Keys', parent: '/settings/integrations', section: 'settings' },
  { path: '/settings/integrations/webhooks', label: 'Webhooks', parent: '/settings/integrations', section: 'settings' },
  { path: '/settings/integrations/channels', label: 'Channel Connections', parent: '/settings/integrations', section: 'settings' },
  { path: '/settings/integrations/third-party', label: 'Third-Party Integrations', parent: '/settings/integrations', section: 'settings' },
  { path: '/settings/integrations/developer', label: 'Developer Console', parent: '/settings/integrations', section: 'settings' },
  { path: '/settings/compliance', label: 'Compliance Overview', parent: '/settings', section: 'settings' },
  { path: '/settings/compliance/status', label: 'Compliance Status', parent: '/settings/compliance', section: 'settings' },
  { path: '/settings/compliance/audit', label: 'Global Audit Log', parent: '/settings/compliance', section: 'settings' },
  { path: '/settings/compliance/reports', label: 'Compliance Reports', parent: '/settings/compliance', section: 'settings' },
  { path: '/settings/compliance/residency', label: 'Data Residency', parent: '/settings/compliance', section: 'settings' },
  { path: '/settings/calibration', label: 'Tenant Calibration', parent: '/settings', section: 'settings' },
  { path: '/settings/calibration/overview', label: 'Overview', parent: '/settings/calibration', section: 'settings' },
  { path: '/settings/calibration/dimensions', label: 'Dimensions', parent: '/settings/calibration', section: 'settings' },
  { path: '/settings/calibration/presets', label: 'Presets', parent: '/settings/calibration', section: 'settings' },
  { path: '/settings/calibration/test', label: 'Testing', parent: '/settings/calibration', section: 'settings' },
  { path: '/settings/calibration/history', label: 'History', parent: '/settings/calibration', section: 'settings' },
  { path: '/settings/governance', label: 'Storage & Governance', parent: '/settings', section: 'settings' },
  { path: '/settings/governance/retention', label: 'Retention Policies', parent: '/settings/governance', section: 'settings' },
  { path: '/settings/governance/storage', label: 'Storage Tiers', parent: '/settings/governance', section: 'settings' },
  { path: '/settings/governance/deletion', label: 'Data Deletion', parent: '/settings/governance', section: 'settings' },
  { path: '/settings/governance/dashboard', label: 'Governance Dashboard', parent: '/settings/governance', section: 'settings' },
  { path: '/settings/notifications', label: 'Notifications', parent: '/settings', section: 'settings' },
  { path: '/settings/notifications/preferences', label: 'Notification Settings', parent: '/settings/notifications', section: 'settings' },
  { path: '/settings/notifications/alerts', label: 'Alert Rules', parent: '/settings/notifications', section: 'settings' },

  // Engage
  { path: '/engage', label: 'Engage', section: 'engage' },
  { path: '/engage/dashboard', label: 'Dashboard', parent: '/engage', section: 'engage' },
  { path: '/engage/personas', label: 'Persona Library', parent: '/engage', section: 'engage' },
  { path: '/engage/skills', label: 'Skill Suite', parent: '/engage', section: 'engage' },
  { path: '/engage/channels', label: 'Channels & Deployment', parent: '/engage', section: 'engage' },
  { path: '/engage/intelligence', label: 'Customer Intelligence', parent: '/engage', section: 'engage' },
  { path: '/engage/analytics', label: 'Analytics & Reports', parent: '/engage', section: 'engage' },
  { path: '/tenant/engage/persona-engine-health', label: 'Persona Engine Health', parent: '/engage', section: 'engage' },
  { path: '/tenant/engage/persona-engine-instances', label: 'Persona Instances', parent: '/engage', section: 'engage' },

  // Personic Profiles
  { path: '/employee/mindmetal/profiles', label: 'Profile Browser', parent: '/admin/models', section: 'admin' },
  { path: '/tenant/profiles', label: 'Profiles', section: 'home' },

  // System Admin
  { path: '/admin', label: 'System Admin', section: 'admin' },
  { path: '/admin/my-profile', label: 'My Profile', section: 'home' },
  { path: '/admin/tenants', label: 'Tenant Operations', parent: '/admin', section: 'admin' },
  { path: '/admin/users', label: 'User Management', parent: '/admin', section: 'admin' },
  { path: '/admin/testing', label: 'Testing & Quality', parent: '/admin', section: 'admin' },
  { path: '/admin/models', label: 'Model & Pipeline', parent: '/admin', section: 'admin' },
  { path: '/admin/analytics', label: 'Platform Analytics', parent: '/admin', section: 'admin' },
  { path: '/admin/compliance', label: 'Compliance Admin', parent: '/admin', section: 'admin' },
  { path: '/admin/ops', label: 'Infrastructure & Ops', parent: '/admin', section: 'admin' },
  { path: '/admin/config', label: 'Content & Config', parent: '/admin', section: 'admin' },
  { path: '/admin/internal', label: 'Internal Tools', parent: '/admin', section: 'admin' },

  // Persona Engine Admin
  { path: '/admin/persona-engine', label: 'Persona Engine', parent: '/admin', section: 'admin' },
  { path: '/admin/persona-engine/archetypes', label: 'Archetype Library', parent: '/admin/persona-engine', section: 'admin' },
  { path: '/admin/persona-engine/roles', label: 'Role Templates', parent: '/admin/persona-engine', section: 'admin' },
  { path: '/admin/persona-engine/graduation', label: 'Graduation Dashboard', parent: '/admin/persona-engine', section: 'admin' },
  { path: '/admin/persona-engine/config', label: 'Engine Config', parent: '/admin/persona-engine', section: 'admin' },
]

/**
 * Build breadcrumb trail for a given path by walking up the parent chain.
 */
export function buildBreadcrumbs(currentPath: string): Array<{ label: string; href?: string }> {
  const items: Array<{ label: string; href?: string }> = []
  let path: string | undefined = currentPath

  while (path) {
    const config = routeConfig.find(r => r.path === path)
    if (!config) break
    items.unshift({ label: config.label, href: config.path })
    path = config.parent
  }

  // Last item has no href (current page)
  if (items.length > 0) {
    delete items[items.length - 1].href
  }

  return items
}
